import { EdgePanConfig } from "./edgepan.types";

export const DEFAULT_EDGE_PAN_CONFIG: EdgePanConfig = {
  ringWidthPercent: 0.325,
  deadZones: {
    top: { value: 125, unit: "px" },
    bottom: { value: 82, unit: "px" },
    left: { value: 0, unit: "px" },
    right: { value: 0, unit: "px" },
  },
  minSpeed: 5,
  maxSpeed: 120,
  activationDelayMs: 100,
  easeInExponent: 2,
};

export const EDGE_PAN_TOGGLE_KEY = "space";
export const EDGE_PAN_OVERLAY_TOGGLE_KEY = "shift+space";

export const OVERLAY_COLORS = {
  corner: "rgba(255, 255, 0, 0.3)",
  edge: "rgba(0, 255, 0, 0.3)",
};
